import React, { useEffect, useState } from 'react';
import { getCustomerFollowUps, addFollowUp } from '../services/followUpApi';

// FOLLOW-UP v1: "Log call" window for one customer.
export const FU_OUTCOMES = [
  ['will_order', 'Will order', 7],
  ['price', 'Price / rate issue', 14],
  ['later', 'Call later', 7],
  ['not_reachable', 'Not reachable', 2],
  ['lost', 'Lost / not interested', 60],
];
export const FU_SHORT = { will_order: 'Will order', price: 'Price issue', later: 'Call later', not_reachable: 'Not reachable', lost: 'Lost' };
const dmy = (s) => (s && /^\d{4}-\d{2}-\d{2}/.test(s) ? `${s.slice(8, 10)}/${s.slice(5, 7)}/${s.slice(0, 4)}` : '—');
const FIELD = { padding: '6px 10px', border: '1px solid var(--color-border, #ccc)', borderRadius: 6, background: 'var(--color-surface, #fff)', color: 'inherit', width: '100%' };

export default function FollowUpModal({ customer, onClose, onSaved }) {
  const [outcome, setOutcome] = useState('will_order');
  const [note, setNote] = useState('');
  const [days, setDays] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [hist, setHist] = useState(null);
  useEffect(() => {
    let off = false;
    getCustomerFollowUps(customer.id).then((x) => { if (!off) setHist(x); }).catch(() => { if (!off) setHist([]); });
    return () => { off = true; };
  }, [customer.id]);
  const defDays = (FU_OUTCOMES.find((o) => o[0] === outcome) || [0, 0, 7])[2];
  const save = () => {
    setBusy(true); setErr('');
    addFollowUp({ customerId: customer.id, outcome, note, snoozeDays: days === '' ? undefined : Number(days) })
      .then(() => { if (onSaved) onSaved(); onClose(); })
      .catch((e) => { setErr((e && e.response && e.response.data && e.response.data.error && e.response.data.error.message) || 'Could not save'); setBusy(false); });
  };
  return (
    <div role="dialog" aria-label="Log call" onClick={onClose}
      style={{ position: 'fixed', inset: 0, zIndex: 3500, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ background: 'var(--color-surface, #fff)', color: 'var(--color-text-primary, #111)', border: '1px solid var(--color-border, #ccc)', borderRadius: 12, width: '100%', maxWidth: 460, maxHeight: '90vh', overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
          <b>Log call — {customer.name}</b>
          <button type="button" onClick={onClose} aria-label="Close" style={{ border: 'none', background: 'transparent', color: 'inherit', cursor: 'pointer', fontSize: 18 }}>✕</button>
        </div>
        <label style={{ fontSize: 13 }}>What happened?
          <select value={outcome} onChange={(e) => setOutcome(e.target.value)} style={{ ...FIELD, marginTop: 4 }}>
            {FU_OUTCOMES.map((o) => <option key={o[0]} value={o[0]}>{o[1]}</option>)}
          </select>
        </label>
        <label style={{ fontSize: 13 }}>Note (optional)
          <textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={500} rows={3} placeholder="e.g. will order 600X600 next week" style={{ ...FIELD, marginTop: 4, resize: 'vertical' }} />
        </label>
        <label style={{ fontSize: 13 }}>Leave this customer alone in the daily Telegram list for (days)
          <input type="number" min="0" max="90" value={days} onChange={(e) => setDays(e.target.value)} placeholder={`${defDays} (default)`} style={{ ...FIELD, marginTop: 4 }} />
        </label>
        {err && <div style={{ color: '#B42318' }}>{err}</div>}
        <button type="button" className="btn btn-primary" disabled={busy} onClick={save}>{busy ? 'Saving…' : 'Save'}</button>
        <div style={{ borderTop: '1px solid var(--color-border, #eee)', paddingTop: 8, fontSize: 13 }}>
          <b>Earlier calls</b>
          {hist === null && <div style={{ opacity: 0.7 }}>Loading…</div>}
          {hist && hist.length === 0 && <div style={{ opacity: 0.7 }}>No call logged yet.</div>}
          {hist && hist.map((h) => (
            <div key={h.id} style={{ padding: '6px 0', borderBottom: '1px solid var(--color-border, #eee)' }}>
              <b>{FU_SHORT[h.outcome] || h.outcome}</b> · {dmy(h.date)}{h.by ? ` · ${h.by}` : ''}
              {h.note ? <div style={{ opacity: 0.8 }}>{h.note}</div> : null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
